import { Button } from '@cocoonspace/ui/components/button'
import { useLingui } from '@lingui/react/macro'
import { StarIcon } from 'lucide-react'

import { LocalizedLink } from '~/components/localized-link'
import { NEED_SEARCH_PATHS } from '~/domains/search/config/need-search-paths'

export const SeminarHeader = () => {
	const { t } = useLingui()

	return (
		<header className='border-border bg-card sticky top-0 z-40 border-b'>
			<nav
				aria-label={t`Navigation principale`}
				className='container mx-auto flex h-[var(--app-navbar-height)] items-center justify-between gap-4 px-5 md:px-8'
			>
				<LocalizedLink
					href='/'
					className='text-primary text-lg font-extrabold tracking-tight md:text-3xl'
				>
					cocoon space
				</LocalizedLink>
				<div className='flex items-center gap-6'>
					<a
						href='https://www.google.com/maps/search/cocoon+space/'
						className='hidden items-center gap-2 text-sm lg:flex'
					>
						<StarIcon
							aria-hidden
							className='text-primary fill-primary size-4'
						/>
						<span>
							<strong>4,8/5</strong> · {t`+600 avis Google`}
						</span>
					</a>
					<Button
						asChild
						className='px-4 md:px-10'
					>
						<LocalizedLink href={NEED_SEARCH_PATHS.seminar}>
							<span className='md:hidden'>{t`Voir les Cocoons`}</span>
							<span className='hidden md:inline'>{t`Voir les Cocoons disponibles`}</span>
						</LocalizedLink>
					</Button>
				</div>
			</nav>
		</header>
	)
}
